<div class="hero-text-with-copy">
  <p>{{ text }}</p>
  <div class="hero-text-action"
    [bitfClipboard]="text">
    <rmx-icon name="file-copy-line"></rmx-icon>
  </div>
</div>
